module.exports = __webpack_public_path__ + "254954631967e7c1876d96a95cbb5f38.pdf";